import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d3dfe9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-block" }
const _hoisted_2 = { class: "landing-block-title" }
const _hoisted_3 = { class: "landing-block-text" }
const _hoisted_4 = { class: "landing-block-content" }
const _hoisted_5 = {
  key: 0,
  class: "landing-block-link-container"
}
const _hoisted_6 = ["href", "target"]

import { PropType, computed } from 'vue';

import HighlightedStoriesBlock from '../Content/HighlightedStoriesBlock.vue';
import HighlightedMelatiBlock from '../Content/HighlightedMelatiBlock.vue';
import NewsletterBlock from '../Content/NewsletterBlock.vue';
import { LandingContentBlock } from '@functions/model/landing-page';


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingContentBlock',
  props: {
  block: {
    type: Object as PropType<LandingContentBlock>,
    required: true
  }
},
  setup(__props) {

const props = __props;

const BASE_HOST = process.env.VUE_APP_BASE_HOST as string;



const url = computed(() =>
  props.block.link?.url.includes(BASE_HOST)
    ? props.block.link.url.replace(new RegExp(`.*?.${BASE_HOST}/?`), '/')
    : props.block.link?.url
);
const isExternalUrl = computed(() => url.value?.includes('http'));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.block.title), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.block.text), 1),
    _createElementVNode("div", _hoisted_4, [
      (__props.block.content?.type === 'highlightedStoriesBlock')
        ? (_openBlock(), _createBlock(HighlightedStoriesBlock, {
            key: 0,
            block: __props.block.content
          }, null, 8, ["block"]))
        : (__props.block.content?.type === 'highlightedMelatiBlock')
          ? (_openBlock(), _createBlock(HighlightedMelatiBlock, {
              key: 1,
              block: __props.block.content
            }, null, 8, ["block"]))
          : (__props.block.content?.type === 'newsletterBlock')
            ? (_openBlock(), _createBlock(NewsletterBlock, {
                key: 2,
                block: __props.block.content,
                "page-type": "landing",
                center: ""
              }, null, 8, ["block"]))
            : _createCommentVNode("", true)
    ]),
    (__props.block.link)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_unref(url) && _unref(isExternalUrl))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "outline-btn landing-block-link",
                href: _unref(url),
                target: __props.block.link.targetBlank ? '_blank' : undefined
              }, _toDisplayString(__props.block.link.name), 9, _hoisted_6))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                class: "outline-btn landing-block-link",
                to: _unref(url)
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.block.link.name), 1)
                ]),
                _: 1
              }, 8, ["to"]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})